import {createSlice} from '@reduxjs/toolkit'
import {Keys} from "../../common/constants/";

interface iSubscription {}

const initialState: iSubscription = {
    subscription: null,
}
export const subscriptionLocalStoreKey = Keys.SUBSCRIPTION
export const subscriptionReducer: any = createSlice({
    name: subscriptionLocalStoreKey,
    initialState,
    reducers: {
        setMySubscription: (state: any, action) => {
            state.subscription = action.payload
            localStorage.setItem(subscriptionLocalStoreKey, JSON.stringify(state));
        },
        getMySubscription: (state?: any): iSubscription => {
            return JSON.parse(localStorage.getItem(subscriptionLocalStoreKey) || '{}');
        }
    }
})

// Action creators are generated for each case reducer function
export const {
    setMySubscription,
    getMySubscription,
} = subscriptionReducer.actions

export default subscriptionReducer.reducer
